<template>
  <div>
    <Header :ifbluepa="ifbluepa"></Header>
    <breadcrumb :secondhref="secondhref" :secondtest="secondtest"></breadcrumb>
    <div class="content-body body-box">
      <div class="main-item">
        <div class="body-left">
          <div class="test-box">
            <div class="test-head">
              <span class="test-title">学会论文</span>
            </div>
            <div class="test-select" style="display: none">
              <select class="btn" @change="viceNavigation($event)">
                <option v-for="(c,index) in cate" :key="index" :id="c.id" :value="c.id" >{{c.title}}</option>
              </select>
            </div>
            <ul class="test-ul">
              <item-paper v-for="(s,index) in science" :key="index" :title="s.title" :create_time="s.create_time" :articleId="s.id" :tabName="topName"></item-paper>
            </ul>
            <div class="test-btns">
              <input class="btn" type="button" value="<<" @click="previousPage"/>
              <input class="btn" type="button" v-for="(value, index) in pageSum" :key="index" :value="value" @click="witchPage">
              <input class="btn" type="button" value="..." v-show="pageSum === 11">
              <input class="btn" type="button" value=">>" @click="nextPage"/>
            </div>
          </div>
        </div>
        <!--<div class="body-right">
          <contact></contact>
        </div>-->
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Footer from '@/components/footer/footer.vue'
import Header from '@/components/header/header.vue'
import breadcrumb from '@/components/breadcrumb/breadcrumb.vue'
import contact from '@/components/contact/contact.vue'
import itemPaper from '@/components/item/itemPaper.vue'
import HttpServer from '@/utils' // 接口请求
import '../../node_modules/bootstrap/dist/js/bootstrap.js'

export default {
  name: 'paper',
  data () {
    return {
      // 所在页面的名称
      topName: 'science',
      // 顶部导航栏
      ifbluepa: {
        color: '#0051bd'
      },
      // 面包屑导航栏
      secondhref: '/paper',
      secondtest: '学会论文',
      // 副导航栏信息
      cate: [],
      // 总页数
      pageSum: 1,
      // 当前所在副导航栏
      ifSelection: 0,
      // 当前所在页面
      page: 1,
      // 论文列表
      science: []
    }
  },
  methods: {
    // 副导航栏
    viceNavigation (event) {
      this.ifSelection = +event.target.value
      HttpServer.get('http://ysw.861718.com/gdics.php/index?act=' + this.topName).then(res => {
        this.science = res.science
        this.cate = res.cate
        this.page = 1
      })
    },
    // 上一页
    previousPage: function () {
      if (this.page !== 1) {
        this.page--
      }
      /* 之前的接口需要带下拉框的值'http://ysw.861718.com/gdics.php/index?act=' + this.topName + '&cateid=' + this.ifSelection + '&page=' + this.page */
      HttpServer.get('http://ysw.861718.com/gdics.php/index?act=' + this.topName + '&page=' + this.page).then(res => {
        this.science = res.science
      })
    },
    // 下一页
    nextPage: function () {
      if (this.page <= this.pageSum - 1) {
        this.page++
      }
      HttpServer.get('http://ysw.861718.com/gdics.php/index?act=' + this.topName + '&page=' + this.page).then(res => {
        this.science = res.science
      })
    },
    // 具体的某页
    witchPage (event) {
      this.page = +event.target.value
      HttpServer.get('http://ysw.861718.com/gdics.php/index?act=' + this.topName + '&page=' + this.page).then(res => {
        this.science = res.science
      })
    }
  },
  mounted () {
    // 调用本页接口
    HttpServer.get('http://ysw.861718.com/gdics.php/index?act=' + this.topName).then(res => {
      this.science = res.science
      this.cate = res.cate
      // this.ifSelection = res.cate[0].id
      this.pageSum = Math.ceil(res.total / res.page_limit)
      if (this.pageSum > 10) {
        this.pageSum = 11
      }
    })
  },
  computed: {
  },
  components: {
    Footer: Footer,
    Header: Header,
    breadcrumb: breadcrumb,
    contact: contact,
    itemPaper: itemPaper
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  @import '../../node_modules/bootstrap/dist/css/bootstrap.css';
  @import 'joinprocess/main.css';
  .body-box{
    margin-top:10px;
    background-color: #f5f5f5;
    overflow: hidden;
  }
  .body-left{
    width: 950px;
    float: left;
  }
  .body-right{
    width: 200px;
    float: right;
  }
  .test-box{
    padding: 12px;
    background-color: #ffffff;
    font-size: 12px;
    text-align: left;
    min-height: 600px;
  }
  .test-head{
    height:30px;
    margin-bottom: 15px;
    border-bottom: 1px solid #d7d7d7;
  }
  .test-title{
    font-size: 14px
  }
  .test-select{
    margin-left: 4px;
    margin-bottom: 20px
  }
  .test-ul{
    list-style: none;
    margin-left: 0px
  }
  .test-btns{
    width: 100%;
    height: 30px;
    text-align: center
  }
  .test-btns input{
    padding: 0 8px;
    margin: 0 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/paper.vue